const BASE_URL = 'lishui-qym-ent'
import request from '@/common/api/request'
// 企业互动-工商信息
export const getEntOpen = params =>
  request(BASE_URL + '/entDetail/getEntOpen', { params })
// 企业互动-企业主页
export const getEntDetail = params =>
  request(BASE_URL + '/entDetail/getEntDetail', { params })

// 企业互动-企业消息
export const getSMSReadReacordByPage = params =>
  request(BASE_URL + '/qymSmsMessage/getSMSReadReacordByPage', { params })

// 企业互动-阅读
export const addSMSReadReacord = params =>
  request.post(BASE_URL + '/qymSmsMessage/addSMSReadReacord', params)

// 企业互动-详情
export const getSMSReadReacordById = params =>
  request(BASE_URL + '/qymSmsMessage/getSMSReadReacordById', { params })
